import { Dialog } from "@mui/material";
import { useState } from "react";
import MultipleChipsField from "../../BaseInputs/MultipleChipsField";
import DialogContentSelectGeneric from "../DialogsContents/DialogContentGeneric";
import { IDataAgrotoxico } from "../../../types/api/geral/pesquisar-agrotoxico";


interface SelectAgrotoxicoProps {
    value: IDataAgrotoxico | IDataAgrotoxico[] | null;
    onChange: (arg: IDataAgrotoxico | IDataAgrotoxico[] | null) => void;
    error?: boolean;
    required?: boolean;
    unique_select?: boolean;
    label?: string;
    helperText?: string;
}

export default function SelectAgrotoxico({
                                             value,
                                             onChange,
                                             required = false,
                                             error = false,
                                             unique_select = false,
                                             helperText,
                                             label = "Agrotóxico"
                                         }: SelectAgrotoxicoProps) {
    const [openModal, setOpenModal] = useState(false);

    const handleOpen = () => setOpenModal(true);
    const handleClose = () => setOpenModal(false);

    const normalizedValue = value
        ? Array.isArray(value)
            ? value
            : [value]
        : [];

    return (
        <>
            <MultipleChipsField
                value={normalizedValue.map(item => ({ ...item, nome: item.marca_comercial }))}
                label={label}
                required={required}
                formatChipLabel={(item) => `${item.id} - ${item.marca_comercial}`}
                onClick={handleOpen}
                error={!!error}
                helperText={error && !helperText ? "Campo obrigatório" : helperText}
            />

            {openModal && (
                <Dialog
                    fullWidth
                    maxWidth="md"
                    open={openModal}
                    onClose={handleClose}
                >
                    <DialogContentSelectGeneric
                        handleClose={handleClose}
                        multiple={!unique_select}
                        possuiBtnLimpar
                        title={`Selecionar Agrotóxico`}
                        queryPath="/receituario-agronomico/agrotoxicos/pesquisar-agrotoxico"
                        getItemKey={(item: any) => item?.id ?? 0}
                        getItemLabel={(item: any) => item ? `${item.id} - ${item.marca_comercial}` : ''}
                        defaultValue={normalizedValue}
                        onChange={(selected: any) => {
                            if (unique_select) {
                                const arr = Array.isArray(selected) ? selected : selected ? [selected] : [];
                                onChange(arr.length > 0 ? arr[0] : null);
                            } else {
                                onChange(Array.isArray(selected) ? selected : (selected ? [selected] : []));
                            }
                            handleClose();
                        }}
                    />
                </Dialog>
            )}
        </>
    );
}